function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "pedigree-far");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "pedigree-far",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("line", {
  x1: 7.20833333,
  y1: 126.5,
  x2: 7.20833333,
  y2: 199.5,
  id: "Line-2-Copy",
  stroke: "#4783A8",
  strokeLinecap: "square",
  fillRule: "nonzero"
}), React.createElement("line", {
  x1: 7.5,
  y1: 126.5,
  x2: 22.5,
  y2: 126.5,
  id: "Line-Copy",
  stroke: "#4783A8",
  strokeLinecap: "square",
  fillRule: "nonzero"
}), React.createElement("text", {
  id: "property-0",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 0,
  y: 234
}, ":")), React.createElement("text", {
  id: "name-0",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 12,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 0,
  y: 248
}, ":")), React.createElement("text", {
  id: "far-name-copy",
  fontFamily: "Helvetica-Bold, Helvetica",
  fontSize: 12,
  fontWeight: "bold",
  fill: "#4783A8"
}, React.createElement("tspan", {
  x: 0,
  y: 218
}, "FAR")), React.createElement("text", {
  id: "far-name-copy",
  fontFamily: "Helvetica-Bold, Helvetica",
  fontSize: 12,
  fontWeight: "bold",
  fill: "#5089AD"
}, React.createElement("tspan", {
  x: 40,
  y: 345
}, "FARMOR")), React.createElement("text", {
  id: "far-name-copy",
  fontFamily: "Helvetica-Bold, Helvetica",
  fontSize: 12,
  fontWeight: "bold",
  fill: "#4783A8"
}, React.createElement("tspan", {
  x: 40,
  y: 105
}, "FARFAR")), React.createElement("text", {
  id: "headline",
  fontFamily: "Helvetica-Bold, Helvetica",
  fontSize: 12,
  fontWeight: "bold",
  fill: "#000000"
}, React.createElement("tspan", {
  x: 1,
  y: 17
}, "TITEL")), React.createElement("text", {
  id: "property-00",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 40,
  y: 118
}, ":")), React.createElement("text", {
  id: "name-00",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 40,
  y: 130
}, ":")), React.createElement("text", {
  id: "property-000",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 80,
  y: 63
}, ":")), React.createElement("text", {
  id: "name-000",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 80,
  y: 75
}, ":")), React.createElement("text", {
  id: "property-0000",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 120,
  y: 33
}, ":")), React.createElement("text", {
  id: "name-0000",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 120,
  y: 45
}, ":")), React.createElement("text", {
  id: "property-0001",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 120,
  y: 91
}, ":")), React.createElement("text", {
  id: "name-0001",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 120,
  y: 103
}, ":")), React.createElement("text", {
  id: "property-001",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 80,
  y: 173
}, ":")), React.createElement("text", {
  id: "name-001",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 80,
  y: 185
}, ":")), React.createElement("text", {
  id: "property-0010",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 120,
  y: 143
}, ": ")), React.createElement("text", {
  id: "name-0010",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 120,
  y: 155
}, ":")), React.createElement("text", {
  id: "property-0011",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 120,
  y: 201
}, ":")), React.createElement("text", {
  id: "name-0011",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 120,
  y: 213
}, ":")), React.createElement("line", {
  x1: 7.20833333,
  y1: 366.5,
  x2: 7.20833333,
  y2: 270.5,
  id: "Line-2-Copy-8",
  stroke: "#A65E5E",
  strokeLinecap: "square",
  fillRule: "nonzero"
}), React.createElement("line", {
  x1: 7.5,
  y1: 366.5,
  x2: 25.5,
  y2: 366.5,
  id: "Line-Copy-8",
  stroke: "#A65E5E",
  strokeLinecap: "square",
  fillRule: "nonzero"
}), React.createElement("text", {
  id: "property-01",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 40,
  y: 358
}, ":")), React.createElement("text", {
  id: "name-01",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 40,
  y: 370
}, ":")), React.createElement("text", {
  id: "property-010",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 80,
  y: 303
}, ":")), React.createElement("text", {
  id: "name-010",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 80,
  y: 315
}, ":")), React.createElement("text", {
  id: "property-0100",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 120,
  y: 273
}, ": ")), React.createElement("text", {
  id: "name-0100",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 120,
  y: 285
}, ":")), React.createElement("text", {
  id: "property-0101",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 120,
  y: 331
}, ":")), React.createElement("text", {
  id: "name-0101",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 120,
  y: 343
}, ":")), React.createElement("text", {
  id: "property-011",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 80,
  y: 413
}, ":")), React.createElement("text", {
  id: "name-011",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 80,
  y: 425
}, ":")), React.createElement("text", {
  id: "property-0110",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 120,
  y: 383
}, ":")), React.createElement("text", {
  id: "name-0110",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 120,
  y: 395
}, ":")), React.createElement("text", {
  id: "property-0111",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 120,
  y: 441
}, ":")), React.createElement("text", {
  id: "name-0111",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 120,
  y: 453
}, ":")), React.createElement("line", {
  x1: 53.2083333,
  y1: 71.5,
  x2: 53.2083333,
  y2: 88.5,
  id: "Line-2-Copy-2",
  stroke: "#4783A8",
  strokeLinecap: "square",
  fillRule: "nonzero"
}), React.createElement("line", {
  x1: 53.5,
  y1: 71.5,
  x2: 67.5,
  y2: 71.5,
  id: "Line-Copy-2",
  stroke: "#4783A8",
  strokeLinecap: "square",
  fillRule: "nonzero"
}), React.createElement("g", {
  id: "han-copy",
  transform: "translate(69.000000, 67.000000)",
  fill: "#4783A8",
  fillRule: "nonzero"
}, React.createElement("path", {
  d: "M8,2.70542612 L8,0 L5.29402098,0 L6.24151546,0.947945432 L5.39908828,1.79035196 C4.06313701,0.842405798 2.19679819,0.962209432 1.00105035,2.15877886 C-0.333927082,3.49323701 -0.333439797,5.66487987 1.00105035,6.99921583 C2.33554123,8.33367398 4.50675078,8.33367398 5.84160603,6.9987402 C7.03773061,5.80217004 7.1584492,3.93575482 6.21004197,2.60032357 L7.05341826,1.75696796 L8,2.70542612 Z M5.0344248,6.19241949 C4.14351134,7.08331183 2.69830575,7.08331183 1.80779375,6.19289585 C0.916405368,5.3015286 0.916879562,3.85683409 1.80779375,2.96585666 C2.69870721,2.07496431 4.1439128,2.07496431 5.0344248,2.96585666 C5.92581318,3.85674827 5.92581318,5.30143115 5.0344248,6.19240858 L5.0344248,6.19241949 Z",
  id: "Fill-1"
})), React.createElement("line", {
  x1: 53.2083333,
  y1: 143.5,
  x2: 53.2083333,
  y2: 183.5,
  id: "Line-2-Copy-4",
  stroke: "#A65E5E",
  strokeLinecap: "square",
  fillRule: "nonzero"
}), React.createElement("line", {
  x1: 53.5,
  y1: 183.5,
  x2: 66.5,
  y2: 183.5,
  id: "Line-Copy-4",
  stroke: "#A65E5E",
  strokeLinecap: "square",
  fillRule: "nonzero"
}), React.createElement("g", {
  id: "teve-copy",
  transform: "translate(70.000000, 179.000000)",
  fill: "#A65E5E",
  fillRule: "nonzero"
}, React.createElement("path", {
  d: "M5.99991576,2.7677757 C5.99991576,1.24163619 4.6540255,0 2.99974454,0 C1.34546358,0 0,1.24163619 0,2.7677757 C0,4.135869 1.08294161,5.27220774 2.4993421,5.49323568 L2.49225855,6.15481548 L1.49552939,6.15789113 L1.49552939,7.07625167 L2.49934132,7.07317602 L2.49934132,8 L3.4956438,8 L3.4956438,7.07317602 L4.49570061,7.07317602 L4.48861784,6.15481548 L3.48856025,6.15481548 L3.4956438,5.49439714 C4.91407083,5.27566191 6,4.13781773 6,2.76775627 L5.99991576,2.7677757 Z M2.99974454,4.61296022 C1.89546803,4.61296022 1.00005681,3.78647481 1.00005681,2.7677757 C1.00005681,1.74903774 1.89552107,0.9225919 2.99974454,0.9225919 C4.10476754,0.9225919 4.99985816,1.74907659 4.99985816,2.7677757 C4.99985816,3.78612075 4.10480967,4.61296022 2.99974454,4.61296022 Z",
  id: "Fill-1"
})), React.createElement("g", {
  id: "Group-6",
  transform: "translate(102.000000, 38.000000)",
  fillRule: "nonzero"
}, React.createElement("g", {
  id: "han-copy",
  transform: "translate(7.000000, 0.000000)",
  fill: "#4783A8"
}, React.createElement("path", {
  d: "M8,2.70542612 L8,0 L5.29402098,0 L6.24151546,0.947945432 L5.39908828,1.79035196 C4.06313701,0.842405798 2.19679819,0.962209432 1.00105035,2.15877886 C-0.333927082,3.49323701 -0.333439797,5.66487987 1.00105035,6.99921583 C2.33554123,8.33367398 4.50675078,8.33367398 5.84160603,6.9987402 C7.03773061,5.80217004 7.1584492,3.93575482 6.21004197,2.60032357 L7.05341826,1.75696796 L8,2.70542612 Z M5.0344248,6.19241949 C4.14351134,7.08331183 2.69830575,7.08331183 1.80779375,6.19289585 C0.916405368,5.3015286 0.916879562,3.85683409 1.80779375,2.96585666 C2.69870721,2.07496431 4.1439128,2.07496431 5.0344248,2.96585666 C5.92581318,3.85674827 5.92581318,5.30143115 5.0344248,6.19240858 L5.0344248,6.19241949 Z",
  id: "Fill-1"
})), React.createElement("line", {
  x1: 1.20833333,
  y1: 4.5,
  x2: 1.20833333,
  y2: 12.5,
  id: "Line-2-Copy-17",
  stroke: "#4783A8",
  strokeLinecap: "square"
}), React.createElement("line", {
  x1: 1.5,
  y1: 4.5,
  x2: 5,
  y2: 4.5,
  id: "Line-Copy-17",
  stroke: "#4783A8",
  strokeLinecap: "square"
})), React.createElement("g", {
  id: "Group-6",
  transform: "translate(102.000000, 148.000000)",
  fillRule: "nonzero"
}, React.createElement("g", {
  id: "han-copy",
  transform: "translate(7.000000, 0.000000)",
  fill: "#4783A8"
}, React.createElement("path", {
  d: "M8,2.70542612 L8,0 L5.29402098,0 L6.24151546,0.947945432 L5.39908828,1.79035196 C4.06313701,0.842405798 2.19679819,0.962209432 1.00105035,2.15877886 C-0.333927082,3.49323701 -0.333439797,5.66487987 1.00105035,6.99921583 C2.33554123,8.33367398 4.50675078,8.33367398 5.84160603,6.9987402 C7.03773061,5.80217004 7.1584492,3.93575482 6.21004197,2.60032357 L7.05341826,1.75696796 L8,2.70542612 Z M5.0344248,6.19241949 C4.14351134,7.08331183 2.69830575,7.08331183 1.80779375,6.19289585 C0.916405368,5.3015286 0.916879562,3.85683409 1.80779375,2.96585666 C2.69870721,2.07496431 4.1439128,2.07496431 5.0344248,2.96585666 C5.92581318,3.85674827 5.92581318,5.30143115 5.0344248,6.19240858 L5.0344248,6.19241949 Z",
  id: "Fill-1"
})), React.createElement("line", {
  x1: 1.20833333,
  y1: 4.5,
  x2: 1.20833333,
  y2: 12.5,
  id: "Line-2-Copy-17",
  stroke: "#4783A8",
  strokeLinecap: "square"
}), React.createElement("line", {
  x1: 1.5,
  y1: 4.5,
  x2: 5,
  y2: 4.5,
  id: "Line-Copy-17",
  stroke: "#4783A8",
  strokeLinecap: "square"
})), React.createElement("g", {
  id: "Group-3",
  transform: "translate(102.000000, 85.000000)",
  fillRule: "nonzero"
}, React.createElement("g", {
  id: "teve-copy",
  transform: "translate(7.000000, 12.000000)",
  fill: "#A65E5E"
}, React.createElement("path", {
  d: "M5.99991576,2.7677757 C5.99991576,1.24163619 4.6540255,0 2.99974454,0 C1.34546358,0 0,1.24163619 0,2.7677757 C0,4.135869 1.08294161,5.27220774 2.4993421,5.49323568 L2.49225855,6.15481548 L1.49552939,6.15789113 L1.49552939,7.07625167 L2.49934132,7.07317602 L2.49934132,8 L3.4956438,8 L3.4956438,7.07317602 L4.49570061,7.07317602 L4.48861784,6.15481548 L3.48856025,6.15481548 L3.4956438,5.49439714 C4.91407083,5.27566191 6,4.13781773 6,2.76775627 L5.99991576,2.7677757 Z M2.99974454,4.61296022 C1.89546803,4.61296022 1.00005681,3.78647481 1.00005681,2.7677757 C1.00005681,1.74903774 1.89552107,0.9225919 2.99974454,0.9225919 C4.10476754,0.9225919 4.99985816,1.74907659 4.99985816,2.7677757 C4.99985816,3.78612075 4.10480967,4.61296022 2.99974454,4.61296022 Z",
  id: "Fill-1"
})), React.createElement("line", {
  x1: 1.20833333,
  y1: 0.5,
  x2: 1.20833333,
  y2: 16.5,
  id: "Line-2-Copy-19",
  stroke: "#A65E5E",
  strokeLinecap: "square"
}), React.createElement("line", {
  x1: 1.5,
  y1: 16.5,
  x2: 5.5,
  y2: 16.5,
  id: "Line-Copy-19",
  stroke: "#A65E5E",
  strokeLinecap: "square"
})), React.createElement("line", {
  x1: 103.208333,
  y1: 152.5,
  x2: 103.208333,
  y2: 160.5,
  id: "Line-2-Copy-20",
  stroke: "#4783A8",
  strokeLinecap: "square",
  fillRule: "nonzero"
}), React.createElement("g", {
  id: "Group",
  transform: "translate(52.000000, 307.000000)",
  fillRule: "nonzero"
}, React.createElement("line", {
  x1: 1.20833333,
  y1: 4.5,
  x2: 1.20833333,
  y2: 21.5,
  id: "Line-2-Copy-2",
  stroke: "#4783A8",
  strokeLinecap: "square"
}), React.createElement("line", {
  x1: 1.5,
  y1: 4.5,
  x2: 15.5,
  y2: 4.5,
  id: "Line-Copy-2",
  stroke: "#4783A8",
  strokeLinecap: "square"
}), React.createElement("g", {
  id: "han-copy",
  transform: "translate(17.000000, 0.000000)",
  fill: "#4783A8"
}, React.createElement("path", {
  d: "M8,2.70542612 L8,0 L5.29402098,0 L6.24151546,0.947945432 L5.39908828,1.79035196 C4.06313701,0.842405798 2.19679819,0.962209432 1.00105035,2.15877886 C-0.333927082,3.49323701 -0.333439797,5.66487987 1.00105035,6.99921583 C2.33554123,8.33367398 4.50675078,8.33367398 5.84160603,6.9987402 C7.03773061,5.80217004 7.1584492,3.93575482 6.21004197,2.60032357 L7.05341826,1.75696796 L8,2.70542612 Z M5.0344248,6.19241949 C4.14351134,7.08331183 2.69830575,7.08331183 1.80779375,6.19289585 C0.916405368,5.3015286 0.916879562,3.85683409 1.80779375,2.96585666 C2.69870721,2.07496431 4.1439128,2.07496431 5.0344248,2.96585666 C5.92581318,3.85674827 5.92581318,5.30143115 5.0344248,6.19240858 L5.0344248,6.19241949 Z",
  id: "Fill-1"
}))), React.createElement("g", {
  id: "Group-2",
  transform: "translate(52.000000, 383.000000)",
  fillRule: "nonzero"
}, React.createElement("line", {
  x1: 1.20833333,
  y1: 0.5,
  x2: 1.20833333,
  y2: 40.5,
  id: "Line-2-Copy-4",
  stroke: "#A65E5E",
  strokeLinecap: "square"
}), React.createElement("line", {
  x1: 1.5,
  y1: 40.5,
  x2: 14.5,
  y2: 40.5,
  id: "Line-Copy-4",
  stroke: "#A65E5E",
  strokeLinecap: "square"
}), React.createElement("g", {
  id: "teve-copy",
  transform: "translate(18.000000, 36.000000)",
  fill: "#A65E5E"
}, React.createElement("path", {
  d: "M5.99991576,2.7677757 C5.99991576,1.24163619 4.6540255,0 2.99974454,0 C1.34546358,0 0,1.24163619 0,2.7677757 C0,4.135869 1.08294161,5.27220774 2.4993421,5.49323568 L2.49225855,6.15481548 L1.49552939,6.15789113 L1.49552939,7.07625167 L2.49934132,7.07317602 L2.49934132,8 L3.4956438,8 L3.4956438,7.07317602 L4.49570061,7.07317602 L4.48861784,6.15481548 L3.48856025,6.15481548 L3.4956438,5.49439714 C4.91407083,5.27566191 6,4.13781773 6,2.76775627 L5.99991576,2.7677757 Z M2.99974454,4.61296022 C1.89546803,4.61296022 1.00005681,3.78647481 1.00005681,2.7677757 C1.00005681,1.74903774 1.89552107,0.9225919 2.99974454,0.9225919 C4.10476754,0.9225919 4.99985816,1.74907659 4.99985816,2.7677757 C4.99985816,3.78612075 4.10480967,4.61296022 2.99974454,4.61296022 Z",
  id: "Fill-1"
}))), React.createElement("g", {
  id: "Group-6",
  transform: "translate(102.000000, 278.000000)",
  fillRule: "nonzero"
}, React.createElement("g", {
  id: "han-copy",
  transform: "translate(7.000000, 0.000000)",
  fill: "#4783A8"
}, React.createElement("path", {
  d: "M8,2.70542612 L8,0 L5.29402098,0 L6.24151546,0.947945432 L5.39908828,1.79035196 C4.06313701,0.842405798 2.19679819,0.962209432 1.00105035,2.15877886 C-0.333927082,3.49323701 -0.333439797,5.66487987 1.00105035,6.99921583 C2.33554123,8.33367398 4.50675078,8.33367398 5.84160603,6.9987402 C7.03773061,5.80217004 7.1584492,3.93575482 6.21004197,2.60032357 L7.05341826,1.75696796 L8,2.70542612 Z M5.0344248,6.19241949 C4.14351134,7.08331183 2.69830575,7.08331183 1.80779375,6.19289585 C0.916405368,5.3015286 0.916879562,3.85683409 1.80779375,2.96585666 C2.69870721,2.07496431 4.1439128,2.07496431 5.0344248,2.96585666 C5.92581318,3.85674827 5.92581318,5.30143115 5.0344248,6.19240858 L5.0344248,6.19241949 Z",
  id: "Fill-1"
})), React.createElement("line", {
  x1: 1.20833333,
  y1: 4.5,
  x2: 1.20833333,
  y2: 12.5,
  id: "Line-2-Copy-17",
  stroke: "#4783A8",
  strokeLinecap: "square"
}), React.createElement("line", {
  x1: 1.5,
  y1: 4.5,
  x2: 5,
  y2: 4.5,
  id: "Line-Copy-17",
  stroke: "#4783A8",
  strokeLinecap: "square"
})), React.createElement("g", {
  id: "Group-6",
  transform: "translate(102.000000, 388.000000)",
  fillRule: "nonzero"
}, React.createElement("g", {
  id: "han-copy",
  transform: "translate(7.000000, 0.000000)",
  fill: "#4783A8"
}, React.createElement("path", {
  d: "M8,2.70542612 L8,0 L5.29402098,0 L6.24151546,0.947945432 L5.39908828,1.79035196 C4.06313701,0.842405798 2.19679819,0.962209432 1.00105035,2.15877886 C-0.333927082,3.49323701 -0.333439797,5.66487987 1.00105035,6.99921583 C2.33554123,8.33367398 4.50675078,8.33367398 5.84160603,6.9987402 C7.03773061,5.80217004 7.1584492,3.93575482 6.21004197,2.60032357 L7.05341826,1.75696796 L8,2.70542612 Z M5.0344248,6.19241949 C4.14351134,7.08331183 2.69830575,7.08331183 1.80779375,6.19289585 C0.916405368,5.3015286 0.916879562,3.85683409 1.80779375,2.96585666 C2.69870721,2.07496431 4.1439128,2.07496431 5.0344248,2.96585666 C5.92581318,3.85674827 5.92581318,5.30143115 5.0344248,6.19240858 L5.0344248,6.19241949 Z",
  id: "Fill-1"
})), React.createElement("line", {
  x1: 1.20833333,
  y1: 4.5,
  x2: 1.20833333,
  y2: 12.5,
  id: "Line-2-Copy-17",
  stroke: "#4783A8",
  strokeLinecap: "square"
}), React.createElement("line", {
  x1: 1.5,
  y1: 4.5,
  x2: 5,
  y2: 4.5,
  id: "Line-Copy-17",
  stroke: "#4783A8",
  strokeLinecap: "square"
})), React.createElement("g", {
  id: "Group-3",
  transform: "translate(102.000000, 195.000000)",
  fillRule: "nonzero"
}, React.createElement("g", {
  id: "teve-copy",
  transform: "translate(7.000000, 12.000000)",
  fill: "#A65E5E"
}, React.createElement("path", {
  d: "M5.99991576,2.7677757 C5.99991576,1.24163619 4.6540255,0 2.99974454,0 C1.34546358,0 0,1.24163619 0,2.7677757 C0,4.135869 1.08294161,5.27220774 2.4993421,5.49323568 L2.49225855,6.15481548 L1.49552939,6.15789113 L1.49552939,7.07625167 L2.49934132,7.07317602 L2.49934132,8 L3.4956438,8 L3.4956438,7.07317602 L4.49570061,7.07317602 L4.48861784,6.15481548 L3.48856025,6.15481548 L3.4956438,5.49439714 C4.91407083,5.27566191 6,4.13781773 6,2.76775627 L5.99991576,2.7677757 Z M2.99974454,4.61296022 C1.89546803,4.61296022 1.00005681,3.78647481 1.00005681,2.7677757 C1.00005681,1.74903774 1.89552107,0.9225919 2.99974454,0.9225919 C4.10476754,0.9225919 4.99985816,1.74907659 4.99985816,2.7677757 C4.99985816,3.78612075 4.10480967,4.61296022 2.99974454,4.61296022 Z",
  id: "Fill-1"
})), React.createElement("line", {
  x1: 1.20833333,
  y1: 0.5,
  x2: 1.20833333,
  y2: 16.5,
  id: "Line-2-Copy-19",
  stroke: "#A65E5E",
  strokeLinecap: "square"
}), React.createElement("line", {
  x1: 1.5,
  y1: 16.5,
  x2: 5.5,
  y2: 16.5,
  id: "Line-Copy-19",
  stroke: "#A65E5E",
  strokeLinecap: "square"
})), React.createElement("g", {
  id: "Group-3",
  transform: "translate(102.000000, 325.000000)",
  fillRule: "nonzero"
}, React.createElement("g", {
  id: "teve-copy",
  transform: "translate(7.000000, 12.000000)",
  fill: "#A65E5E"
}, React.createElement("path", {
  d: "M5.99991576,2.7677757 C5.99991576,1.24163619 4.6540255,0 2.99974454,0 C1.34546358,0 0,1.24163619 0,2.7677757 C0,4.135869 1.08294161,5.27220774 2.4993421,5.49323568 L2.49225855,6.15481548 L1.49552939,6.15789113 L1.49552939,7.07625167 L2.49934132,7.07317602 L2.49934132,8 L3.4956438,8 L3.4956438,7.07317602 L4.49570061,7.07317602 L4.48861784,6.15481548 L3.48856025,6.15481548 L3.4956438,5.49439714 C4.91407083,5.27566191 6,4.13781773 6,2.76775627 L5.99991576,2.7677757 Z M2.99974454,4.61296022 C1.89546803,4.61296022 1.00005681,3.78647481 1.00005681,2.7677757 C1.00005681,1.74903774 1.89552107,0.9225919 2.99974454,0.9225919 C4.10476754,0.9225919 4.99985816,1.74907659 4.99985816,2.7677757 C4.99985816,3.78612075 4.10480967,4.61296022 2.99974454,4.61296022 Z",
  id: "Fill-1"
})), React.createElement("line", {
  x1: 1.20833333,
  y1: 0.5,
  x2: 1.20833333,
  y2: 16.5,
  id: "Line-2-Copy-19",
  stroke: "#A65E5E",
  strokeLinecap: "square"
}), React.createElement("line", {
  x1: 1.5,
  y1: 16.5,
  x2: 5.5,
  y2: 16.5,
  id: "Line-Copy-19",
  stroke: "#A65E5E",
  strokeLinecap: "square"
})), React.createElement("g", {
  id: "Group-3",
  transform: "translate(102.000000, 435.000000)",
  fillRule: "nonzero"
}, React.createElement("g", {
  id: "teve-copy",
  transform: "translate(7.000000, 12.000000)",
  fill: "#A65E5E"
}, React.createElement("path", {
  d: "M5.99991576,2.7677757 C5.99991576,1.24163619 4.6540255,0 2.99974454,0 C1.34546358,0 0,1.24163619 0,2.7677757 C0,4.135869 1.08294161,5.27220774 2.4993421,5.49323568 L2.49225855,6.15481548 L1.49552939,6.15789113 L1.49552939,7.07625167 L2.49934132,7.07317602 L2.49934132,8 L3.4956438,8 L3.4956438,7.07317602 L4.49570061,7.07317602 L4.48861784,6.15481548 L3.48856025,6.15481548 L3.4956438,5.49439714 C4.91407083,5.27566191 6,4.13781773 6,2.76775627 L5.99991576,2.7677757 Z M2.99974454,4.61296022 C1.89546803,4.61296022 1.00005681,3.78647481 1.00005681,2.7677757 C1.00005681,1.74903774 1.89552107,0.9225919 2.99974454,0.9225919 C4.10476754,0.9225919 4.99985816,1.74907659 4.99985816,2.7677757 C4.99985816,3.78612075 4.10480967,4.61296022 2.99974454,4.61296022 Z",
  id: "Fill-1"
})), React.createElement("line", {
  x1: 1.20833333,
  y1: 0.5,
  x2: 1.20833333,
  y2: 16.5,
  id: "Line-2-Copy-19",
  stroke: "#A65E5E",
  strokeLinecap: "square"
}), React.createElement("line", {
  x1: 1.5,
  y1: 16.5,
  x2: 5.5,
  y2: 16.5,
  id: "Line-Copy-19",
  stroke: "#A65E5E",
  strokeLinecap: "square"
})));

var SvgPedigreeFar = function SvgPedigreeFar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "258px",
    height: "470px",
    viewBox: "0 0 258 470",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPedigreeFar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pedigree-far.be91f444.svg";
export { ForwardRef as ReactComponent };